var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import classnames from 'classnames';
import { Dropdown as SemanticDropdown, DropdownDivider, DropdownHeader, DropdownItem, DropdownMenu, DropdownSearchInput, Ref, } from 'semantic-ui-react';
import { DropdownIcon } from './DropdownIcon';
import { debounce } from '../../utilities/debounce';
import { Icon } from '../Icon';
import { FormFieldContext } from '../FormField';
export class Dropdown extends Component {
    constructor(props) {
        var _a;
        super(props);
        this.handleSearch = () => {
            if (Array.isArray(this.props.value)) {
                return this.getOptionsWithoutValue(this.state.options);
            }
            return this.state.options;
        };
        this.handleFocus = (event, data) => {
            const searchData = Object.assign(Object.assign({}, this.props), { searchQuery: '' });
            this.handleSearchChange(event, searchData);
            if (this.props.onFocus) {
                this.props.onFocus(event, data);
            }
        };
        this.handleSearchChange = debounce((event, data) => __awaiter(this, void 0, void 0, function* () {
            this.setState({ loading: true });
            const options = this.getOptionsWithValue(yield this.props.asyncOptions.dataFetcher(data.searchQuery));
            this.setState({ options, loading: false });
            if (this.props.onSearchChange) {
                this.props.onSearchChange(event, data);
            }
        }));
        this.handleClearClick = (event) => {
            if (this.props.onChange)
                this.props.onChange(event, { value: undefined });
        };
        this.getClearIcon = () => {
            if (this.isEmptyValue || !this.props.clearable) {
                return null;
            }
            return (React.createElement(Icon, { name: "clear", className: "Select__clear-icon", onClick: this.handleClearClick }));
        };
        this.state = {
            loading: false,
            options: ((_a = props.asyncOptions) === null || _a === void 0 ? void 0 : _a.initial) || [],
        };
        this.dropdownRef = React.createRef();
    }
    componentDidMount() {
        this.context.setFormFieldContext({ inputRef: this.dropdownRef });
    }
    getOptionsWithValue(options) {
        const values = this.arrayValue;
        const missingOptions = values
            .filter((value) => options.findIndex((option) => option.value === value) === -1)
            .map((value) => this.state.options.find((option) => option.value === value));
        if (missingOptions.length > 0) {
            options.push(...missingOptions);
        }
        return options;
    }
    getOptionsWithoutValue(options) {
        const values = this.arrayValue;
        const optionsWithoutValue = options.filter((option) => values.findIndex((value) => option.value === value) === -1);
        return optionsWithoutValue;
    }
    get isEmptyValue() {
        return (this.props.value === undefined ||
            this.props.value === '' ||
            (Array.isArray(this.props.value) && this.props.value.length === 0));
    }
    get arrayValue() {
        return this.isEmptyValue
            ? []
            : !Array.isArray(this.props.value)
                ? [this.props.value]
                : this.props.value;
    }
    render() {
        const _a = this.props, { asyncOptions, clearable, className } = _a, passedProps = __rest(_a, ["asyncOptions", "clearable", "className"]);
        const props = Object.assign({}, passedProps);
        props.className = classnames(className, {
            'Select--clearable': clearable,
        });
        if (asyncOptions) {
            props.search = this.handleSearch; // hijack search when data fetcher present as search happens remotely
            props.onSearchChange = this.handleSearchChange;
            props.onFocus = asyncOptions.fetchOnFocus
                ? this.handleFocus
                : props.onFocus;
            props.loading = this.state.loading;
            props.options = this.state.options;
        }
        return (React.createElement("div", { className: "semantic-anvil-theme Select-wrapper" },
            React.createElement(Ref, { innerRef: this.dropdownRef },
                React.createElement(SemanticDropdown, Object.assign({}, props))),
            this.getClearIcon()));
    }
}
Dropdown.Divider = DropdownDivider;
Dropdown.Header = DropdownHeader;
Dropdown.Item = DropdownItem;
Dropdown.Menu = DropdownMenu;
Dropdown.SearchInput = DropdownSearchInput;
Dropdown.defaultProps = {
    icon: React.createElement(DropdownIcon, null),
};
Dropdown.contextType = FormFieldContext;
//# sourceMappingURL=Dropdown.js.map